/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/no-unused-expressions */
/* eslint-disable max-len */
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, QueryList, Renderer2, TemplateRef, ViewChild, ViewChildren, ViewContainerRef, ViewEncapsulation, EventEmitter, Output } from '@angular/core';
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { TemplatePortal } from '@angular/cdk/portal';
import { MatButton } from '@angular/material/button';
import { Subject, Subscription } from 'rxjs';
import _ from 'lodash';
import { takeUntil } from 'rxjs/operators';
import { Notification } from 'app/layout/common/notifications/notifications.types';
import { NotificationsService } from 'app/layout/common/notifications/notifications.service';
import { DataCollectorService } from 'app/core/services/data_collector_services/data_collector_service.service';
import { UtilityService } from 'app/core/services/utility_functions/utility_functions.service';
import { ModuleIcon } from 'app/interfaces/module-icon.interface';
import { HotToastService } from '@ngneat/hot-toast';

@Component({
    selector       : 'notifications',
    templateUrl    : './notifications.component.html',
    styleUrls      : ['./notification.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    exportAs       : 'notifications'
})
export class NotificationsComponent implements OnInit, OnDestroy
{
    @Output() openBroadcastDrawer = new EventEmitter<any>();

    @ViewChild('notificationsOrigin') private _notificationsOrigin: MatButton;
    @ViewChild('notificationsPanel') private _notificationsPanel: TemplateRef<any>;
    @ViewChildren('notificationElement') private _notificationElement: QueryList<ElementRef>;

    notifications: Notification[];
    allNotifications: Array<any>;
    unreadCount: number = 0;
    showLoader: boolean = false;

    companyModules: any= [];
    allModules: any = {};
    moduleFilter: string='';
    all_notifications_total_pages: number;
    all_notifications_current_page: number;
    view_index: number = 0;

    //API
    get getNotificationApi(): any{
        return `${this._dataCollectorService.baseurl()}/user_notifications`;
    }
    get markNotificationsReadApi(): any{
        return `${this._dataCollectorService.baseurl()}/user_notifications/read`;
    }
    get getNotificationCountApi(): any{
        return `${this._dataCollectorService.baseurl()}/user_notifications/count`;
    }
    get deleteNotificationApi(): any{
        return `${this._dataCollectorService.baseurl()}/user_notifications/`;
    }

    private _paginator: Subscription;
    private _overlayRef: OverlayRef;
    private _unsubscribeAll: Subject<void> = new Subject<void>();


    /**
     * Constructor
     */
    constructor(
        private _changeDetectorRef: ChangeDetectorRef,
        private _notificationsService: NotificationsService,
        private _overlay: Overlay,
        private _viewContainerRef: ViewContainerRef,
        private _dataCollectorService: DataCollectorService,
        private _utilityService: UtilityService,
        private _toast: HotToastService,
        private _utility: UtilityService,
        private _renderer: Renderer2
    )
    {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------


    /**
     * On init
     */
    ngOnInit(): void
    {
        this.showLoader = false;
        this.allModules = {};
        this.companyModules = localStorage.getItem('company_modules')?JSON.parse(localStorage.getItem('company_modules')):[];
        this.companyModules = _.map(this.companyModules,'module');
        this.companyModules = [{module_name:'Any', module_key:'', module_uid:''}, ...this.companyModules];
        this.companyModules.map((e)=>{
            if(e.module_key === 'MAPS'){
                this.allModules['ROUTE'] = e.module_name;
            }else if(e.module_key === 'ESTIMATES'){
                this.allModules['ESTIMATES'] = 'Quotes';
            }else if(e.module_key === 'SERVICE_CONTRACTS'){
                this.allModules['SERVICE_CONTRACTS'] = 'Contracts';
            }else if(e.module_key === 'USER'){
                this.allModules['USER'] = 'Employees';
            }else{
                this.allModules[e.module_key] = e.module_name;
            }
        });
        // Subscribe to notification changes
        this._notificationsService.notificationCount$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((notification_count: any) => {
                // Load the notifications
                if(notification_count?.count){
                    this.unreadCount = notification_count.count;
                }else{
                    this.unreadCount = notification_count;
                }
                // Mark for check
                this._changeDetectorRef.markForCheck();
            });
    }

    selectModuleFilter(key: string): void {
        this.allNotifications = [];
        this.all_notifications_current_page = 1;
        if(key === 'MAPS'){
            this.moduleFilter = 'ROUTE';
        }else{
            this.moduleFilter = key;
        }
    }

    viewMoreNotification(): void{
        if(this.all_notifications_current_page === 1 && this.allNotifications.length > 5){
            this.all_notifications_current_page = Math.floor((this.allNotifications.length / 5) + 1);
        }else{
            this.all_notifications_current_page++;
        }
        this.getAllNotifications();
    }

    scrollIntoView(index): void{
        const element = this._renderer.selectRootElement('#notification_'+index, true);
        element.scrollIntoView({ behavior: 'smooth' });
    }

    getAllNotifications(count?: number): void {
        this.showLoader = true;
        if(this.allNotifications.length > 0){
            this.view_index = this.allNotifications.length - 1;
        }else{
            this.view_index = 0;
        }
        const filterObj = {
            'page' :  this.all_notifications_current_page,
            'count' : count || 5,
            'sort_by': 'created_at',
            'sort' : 'DESC',
            'filter.module':this.moduleFilter
          };

        this._dataCollectorService.getData(this.getNotificationApi,this._utilityService.constructParam(filterObj)).subscribe((response: any)=>{
            this.showLoader = false;
            if(this.allNotifications.length > 0){
                this.allNotifications = [...this.allNotifications, ...response.data];
                this._changeDetectorRef.markForCheck();
            }else{
                this.allNotifications = response.data;
                this._paginator = this._notificationElement.changes.subscribe(() => {
                    if(this.view_index>0){
                        this.scrollIntoView(this.view_index);
                    }
                 });
            }
            this.all_notifications_total_pages = response.total_pages;
            this.all_notifications_current_page = response.current_page;

          },
          (err: any) =>{
              this.showLoader = false;
              
            });
    }

    getLocaleValue(value): string{
        return this._utility.getLocaleValue(value);
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void
    {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();

        // Dispose the overlay
        if ( this._overlayRef )
        {
            this._overlayRef.dispose();
        }
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Open the notifications panel
     */
    openPanel(): void
    {
        this.moduleFilter = '';
        setTimeout(()=>{
            this.all_notifications_current_page = 1;
            this.getAllNotifications();
        }
        ,200);
        this.allNotifications = [];
        this.view_index = 0;
        this.showLoader = true;

        // Return if the notifications panel or its origin is not defined
        if ( !this._notificationsPanel || !this._notificationsOrigin )
        {
            return;
        }

        // Create the overlay if it doesn't exist
        if ( !this._overlayRef )
        {
            this._createOverlay();
        }

        // Attach the portal to the overlay
        this._overlayRef.attach(new TemplatePortal(this._notificationsPanel, this._viewContainerRef));


    }

    /**
     * Close the messages panel
     */
    closePanel(): void
    {
        this.view_index = 0;
        this.allNotifications = [];
        this._overlayRef.detach();
        this.all_notifications_current_page = 1;
        this._paginator.unsubscribe();
    }
    /**
     * Read the notification
     */
    onNotificationRead(objNotification): void {
        const moduleName = objNotification?.module === 'TIMEOFF_REQUEST' ? 'TIMESHEET' : objNotification?.module === 'NON_JOB_EVENT' ? 'SCHEDULE' : objNotification?.module;
        if (!this._utilityService.hasModuleAccess(moduleName)) {
            return;
        }
        this.markNotificationAsRead('mark_one_read', objNotification);
        this.closePanel();
    }

    markNotificationAsRead(action, notification): void {
        if(action === 'mark_all_read')
        {

         this.allNotifications = this.allNotifications.map((e: any)=>{
             e.is_read = 1;
             return e;
          });
          const config = {
            mark_all_read : true
          };
          this.markAsRead(config, action);
        }
        else if(action === 'mark_one_read' && notification && !notification.is_read){
          const config = [];
          config.push(notification.user_notification_uid);
          notification.is_read = 1;
          this.markAsRead(config,action);
        }
      }

      markAsRead(config, action): void {
          const params_obj={};
          if(action === 'mark_all_read'){
            params_obj['mark_all_read'] = config.mark_all_read;
          }
          if(action === 'mark_one_read'){
            params_obj['notification_uids'] = config;
          }
          this._dataCollectorService.postData(this.markNotificationsReadApi,this._utilityService.constructParam(params_obj)).subscribe((response: any)=>{

          if(action === 'mark_all_read')
          {
            this.unreadCount = 0;
          }
          else if(action === 'mark_one_read'){
            this.unreadCount = this.unreadCount - config.length;
          }
          this._changeDetectorRef.detectChanges();
          this.getNotificationCount();
        }, function(err) {
            
        });
    }

    getNotificationCount(): void{
        this._dataCollectorService.getData(this.getNotificationCountApi,this._utilityService.constructParam({})).subscribe((response: any)=>{
            this.unreadCount = response['count'];
        }, (err: any) => {
            
        });
    }

    deleteNotification(notification): void{
        this._dataCollectorService.deleteData(this.deleteNotificationApi+notification.user_notification_uid)
            .subscribe((res: any)=>{

                const count = this.allNotifications.length;
                this.all_notifications_current_page = 1;
                this.allNotifications = [];
                this.getAllNotifications(count);
                this._toast.success(res?.message);
            }, (err: any)=>{
                
            });
    }

    getIconClass(module: string): string {
        return ModuleIcon[module] ?? 'ti ti-bell font-normal';
    }

    getMenuLink(notification: any): string{
        const moduleName = notification?.module === 'TIMEOFF_REQUEST' ? 'TIMESHEET' : notification?.module === 'NON_JOB_EVENT' ? 'SCHEDULE' : notification?.module;
        if (!this._utilityService.hasModuleAccess(moduleName)) {
            return null;
        }
        if(notification?.module ==='JOB'){
            return `/jobs/${notification.action_uid}/details`;
        }else if(notification?.module === 'CUSTOMER'){
            return `/customers/${notification.action_uid}/details`;
        }else if(notification?.module === 'ESTIMATE'){
            return `/estimates/${notification.action_uid}/details`;
        }else if(notification?.module === 'INVOICE'){
            return `/invoices/${notification.action_uid}/details`;
        }else if(notification?.module === 'SERVICE_CONTRACT'){
            return `/contracts/${notification.action_uid}/details`;
        }else if(notification?.module === 'USER'){
            return `/employees/${notification.action_uid}/details`;
        }else if(notification?.module === 'TIMEOFF_REQUEST'){
            return `/timeoff`;
        }else if(notification?.module === 'NON_JOB_EVENT'){
            return `/calendar`;
        }else if(notification?.module === 'REQUEST'){
            return `/request/${notification.action_uid}/details`;
        }else if(notification?.module === 'PROJECT'){
            return `/projects/${notification.action_uid}/details`;
        }else{
            return '';
        }
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Private methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Create the overlay
     */
    private _createOverlay(): void
    {
        // Create the overlay
        this._overlayRef = this._overlay.create({
            hasBackdrop     : true,
            backdropClass   : 'zuper-backdrop-on-mobile',
            scrollStrategy  : this._overlay.scrollStrategies.block(),
            positionStrategy: this._overlay.position()
                                  .flexibleConnectedTo(this._notificationsOrigin._elementRef.nativeElement)
                                  .withLockedPosition(true)
                                  .withPush(true)
                                  .withPositions([
                                      {
                                          originX : 'start',
                                          originY : 'bottom',
                                          overlayX: 'start',
                                          overlayY: 'top'
                                      },
                                      {
                                          originX : 'start',
                                          originY : 'top',
                                          overlayX: 'start',
                                          overlayY: 'bottom'
                                      },
                                      {
                                          originX : 'end',
                                          originY : 'bottom',
                                          overlayX: 'end',
                                          overlayY: 'top'
                                      },
                                      {
                                          originX : 'end',
                                          originY : 'top',
                                          overlayX: 'end',
                                          overlayY: 'bottom'
                                      }
                                  ])
        });

        // Detach the overlay from the portal on backdrop click
        this._overlayRef.backdropClick().subscribe(() => {
            this._overlayRef.detach();
        });
    }

    //Broadcast
    openBroadcastDrawerHandler(): void {
        this.openBroadcastDrawer.emit({openDrawer: true});
        this.closePanel();
    }
}
